import { EMPTY, of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { IdBalloonOfferTypes } from "../../../../constants/IdBalloonOfferTypes";
import { selectBalloonContentInfo, selectBalloonRemainingTime, } from "../../../../selectors/selectBalloonInfo";
import { utilTime } from "../../../../utils/utilTime";
import { TypeActionModal } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionBalloonInfo, actionBalloonInfoRequest } from "../actionBalloonInfo";
export var epicBalloonOfferClose = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return ((action.type === TypeActionModal.Close ||
            action.type === TypeActionModal.CloseLast) &&
            action.modalId === IdModal.BalloonOffer);
    }), switchMap(function () {
        var state = state$.value;
        var balloonContentInfo = selectBalloonContentInfo(state);
        var timestamp = selectBalloonRemainingTime(state);
        var secondsLeft = utilTime.secondsLeftTill(timestamp);
        if (balloonContentInfo &&
            balloonContentInfo.balloonOfferTypeId === IdBalloonOfferTypes.Free) {
            return of(actionBalloonInfo({
                balloonContentId: undefined,
                balloonLevel: undefined,
            }));
        }
        else if (balloonContentInfo && secondsLeft < 0) {
            return of(actionBalloonInfoRequest());
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/balloon/epics/epicBalloonOfferClose.ts
// module id = 1899
// module chunks = 3